/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistarttitle3Inputs */

const en_eventaistarttitle3 = /** @type {(inputs: Eventaistarttitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New event`)
};

const de_eventaistarttitle3 = /** @type {(inputs: Eventaistarttitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Event`)
};

/**
* | output |
* | --- |
* | "New event" |
*
* @param {Eventaistarttitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistarttitle3 = /** @type {((inputs?: Eventaistarttitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistarttitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistarttitle3(inputs)
	return de_eventaistarttitle3(inputs)
});
export { eventaistarttitle3 as "eventAiStartTitle" }